module.exports = __webpack_public_path__ + "img/kempinski-palace-engelberg_0.5c848f08.jpg";